import { useAuth } from '../AuthProvider';

export const usePermissions = () => {
  const { user } = useAuth();
  const doctorType = user?.doctorType;
  return {
    canSeeDentalChart: doctorType === 'dentist',
  };
};
